import { useState, useEffect } from 'react';
import { API_BASE } from '../api';
import { getToken } from '../auth';

// 返回当前是否联网
// navigator.onLine + online/offline 事件在 iOS Safari 不可靠 (飞行模式切换不触发)
// 因此额外每 5s 主动探测一次网络, fetch 失败则判定离线
export function useOnlineStatus() {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const on = () => setIsOnline(true);
        const off = () => setIsOnline(false);
        window.addEventListener('online', on);
        window.addEventListener('offline', off);

        // 主动探测: navigator.onLine 在 iOS Safari 误判时兜底
        const probe = async () => {
            try {
                const ctrl = new AbortController();
                const t = setTimeout(() => ctrl.abort(), 2500);
                const headers = {};
                const tok = getToken();
                if (tok) headers.Authorization = `Bearer ${tok}`;
                const r = await fetch(`${API_BASE}/api/home`, { signal: ctrl.signal, headers });
                clearTimeout(t);
                setIsOnline(r.ok);
            } catch (e) {
                setIsOnline(false);
            }
        };
        probe();
        const timer = setInterval(probe, 5000);
        return () => {
            window.removeEventListener('online', on);
            window.removeEventListener('offline', off);
            clearInterval(timer);
        };
    }, []);

    return isOnline;
}
